exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cloudfoundry-deploy-service-stage .btn-add-tag {\n  margin-left: 1.25rem;\n}\n.cloudfoundry-deploy-service-stage .badge {\n  margin-left: 0.2rem;\n}\n.cloudfoundry-deploy-service-stage .badge .close {\n  margin-left: 0.25rem;\n  font-size: 100%;\n}\n", ""]);

